import en from 'translations/en/confirmWithCodePopUp.json';
import pl from 'translations/pl/confirmWithCodePopUp.json';
import sl from 'translations/sl/confirmWithCodePopUp.json';
import { ITranslations } from 'types/common';
import { ConfirmWithCodePopUpTransFields } from './types';

export const confirmWithCodePopUpTranslations: ITranslations<ConfirmWithCodePopUpTransFields> = {
  name: 'confirmWithCodePopUp',
  en,
  pl,
  sl,
};
